// import Vue from 'vue'

export const SaveClaimMixin = {
  // Using beforeRouterEnter instead of created or any vue lifecycle because
  // Using vue lifecycle does not guarantee components are created before previous components are destroyed (the way how vue router deals with routing/lifecycle)
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // It listens to global event hub on event
      // It calls the page that listen to this to initiate doPartialSave
      // all quotation/proposal page should have this method (even if it is empty)
      vm.$root.$on('saveClaim', (toExit = false) => {
        vm.doPartialSave().then(response => {
          if (response === true && toExit) {
            vm.$root.$emit('leaveClaim')
          }
        })
      })
    })
  },
  // Not using vue router lifecycle (beforeRouteLeave) here because leaveClaim is using that lifeCycle to do its init work
  beforeDestroy() {
    this.$root.$off('saveClaim')
  }
}
